import { useNavigate } from "react-router-dom";

const problems = [
  {
    id: "sum",
    title: "Sum of Two Numbers",
    desc: "Basic input output problem",
  },
  {
    id: "palindrome",
    title: "Palindrome Check",
    desc: "String logic based problem",
  },
];

export default function CodingLab() {
  const navigate = useNavigate();

  return (
    <>
      <h1 className="text-2xl font-bold mb-4">💻 Coding Lab</h1>

      <div className="grid md:grid-cols-2 gap-6">
        {problems.map((p) => (
          <div
            key={p.id}
            className="bg-white/5 border border-gray-800 rounded-xl p-6 cursor-pointer hover:shadow-lg hover:-translate-y-1 transition"
            onClick={() => navigate(`/compiler?problem=${p.id}`)}
          >
            <h3 className="text-lg font-semibold">{p.title}</h3>
            <p className="text-gray-400 text-sm mt-2">{p.desc}</p>
            <span className="text-xs text-blue-400 mt-4 inline-block">
              Open Problem →
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
